/* Device ValueSets and constants */

import defaultSound from '../../components/sounds/default.mp3';
import archiveSound from '../../components/sounds/archive.mp3';
import clickSound from '../../components/sounds/click.mp3';
import instrumentSound from '../../components/sounds/instrument.mp3';
import dropSound from '../../components/sounds/drop.mp3';
import stopSound from '../../components/sounds/stop.mp3';
import dingSound from '../../components/sounds/ding.mp3';
import logoffSound from '../../components/sounds/logoff.mp3';

export const NOTIFICATION_SOUNDS = [
  {
    name: 'Default',
    id: 'default',
    sound: defaultSound,
  },
  {
    name: 'Archive',
    id: 'archive',
    sound: archiveSound,
  },
  {
    name: 'Click',
    id: 'click',
    sound: clickSound,
  },
  {
    name: 'Instrument',
    id: 'instrument',
    sound: instrumentSound,
  },
  {
    name: 'Drop',
    id: 'drop',
    sound: dropSound,
  },
  {
    name: 'Stop',
    id: 'stop',
    sound: stopSound,
  },
  {
    name: 'Ding',
    id: 'ding',
    sound: dingSound,
  },
  {
    name: 'Logoff',
    id: 'logoff',
    sound: logoffSound,
  },
]